import React from "react";
import HeaderContainer from "../Header/HeaderContainer";

import { Affix, Col, Grid, Layout, Row, Space, Typography } from "antd";
import transferenceIcon from "assets/namespace/icons/tfrIcon";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import Icon from "@ant-design/icons";
import BackBtn from "components/reusables/BackBtn/BackBtnComponent";
import NextStepBtnComponent from "components/reusables/NextStepBtn/NextStepBtnComponent";
import { AccordionNavComponentTypes } from "components/reusables/AccordionNav/AccordionNavComponent.types";
import MinimalFooterComponent from "components/reusables/MinimalFooter/MinimalFooterComponent";
import InfoCarousel from "components/reusables/InfoCarousel/InfoCarouselComponent";
import NextBackBtnComponent from "components/reusables/NextBackBtn/NextBackBtnComponent";
import { IButtonsNavTypes } from "components/reusables/ButtonsNav/ButtonsNav.types";
import "./BodyContentStyles.scss";
const { Title } = Typography;
const { useBreakpoint } = Grid;

/* Accordion Content images */
//first accordion vehicleInfo
import generalInfo1 from "../../../assets/namespace/img/1_info_general.png";
import generalInfo2 from "../../../assets/namespace/img/2_info_general.png";
import infoPdc3 from "../../../assets/namespace/img/3_info_pdc.png";
import infoPago4 from "../../../assets/namespace/img/4_info_pago.png";

//accordion businesInfo
import buyerInfo1 from "../../../assets/namespace/img/5_comprador_1.png";
import buyerInfo2 from "../../../assets/namespace/img/5_comprador_2.png";
import sellerInfo1 from "../../../assets/namespace/img/6_vendedor_1.png";
import sellerInfo2 from "../../../assets/namespace/img/6_vendedor_2.png";

import vehicleInfo from "../../../assets/namespace/img/vehicle_info.png";
import businessInfo from "../../../assets/namespace/img/business_info.png";
import businessDocuments from "../../../assets/namespace/img/business_documents.png";

//accordion docsInfoContent
import thanks from "../../../assets/namespace/img/7_gracias.png";
import TextHeaderComponent from "components/reusables/TexlHeader/TextHeaderComponent";
import CardComponent from "components/reusables/Card/CardComponent";

/* end content images */
const TfrIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={transferenceIcon} {...props} />
);
const { Header, Sider, Content, Footer } = Layout;

const vehicleInfoContent = () => (
  <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
    <div className="contentLabel">
      Para realizar la transferencia es requisito tener información detallada
      del vehículo y que éste no presente limitaciones al dominio, además se
      debe tener el documento del último permiso de circulación, entre otros.
    </div>
    <InfoCarousel items={[generalInfo1, generalInfo2, infoPdc3, infoPago4]} />
  </div>
);

const businessInfoContent = () => (
  <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
    <div className="contentLabel">
      La información a ingresar debe ser fidedigna ya que si no se ingresan bien
      los datos habrá error en el proceso y tomará más tiempo.
    </div>
    <InfoCarousel items={[buyerInfo1, buyerInfo2, sellerInfo1, sellerInfo2]} />
  </div>
);
const docsInfoContent = () => (
  <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
    <div className="contentLabel">
      Luego de completar toda la información solicitada, Autofact genera los
      documentos oficiales en un tiempo de 3 horas, pero si existe algún error
      en la información proporcionada, pasa a revisión manual.
    </div>
    <InfoCarousel items={[thanks]} />
  </div>
);

const TabsInfo: IButtonsNavTypes = {
  TabsContent: [
    {
      title: "Información del vehículo",
      slug: "vehicle-info",
      text: "Para realizar la transferencia es requisito tener información detallada del vehículo y que éste no presente limitaciones al dominio, además se debe tener el documento del último permiso de circulación, entre otros.",
      contentImg: vehicleInfo,
    },
    {
      title: "Información del comprador y vendedor",
      slug: "business-info",
      text: "La información a ingresar debe ser fidedigna ya que si no se ingresan bien los datos habrá error en el proceso y tomará más tiempo.",
      contentImg: businessInfo,
    },
    {
      title: "Documentos compraventa",
      slug: "business-docs",
      text: "Luego de completar toda la información solicitada, Autofact genera los documentos oficiales en un tiempo de 3 horas, pero si existe algún error en la información proporcionada, pasa a revisión manual.",
      contentImg: businessDocuments,
    },
  ],
};
const AvailableInfo: AccordionNavComponentTypes = {
  AvailableContent: [
    {
      title: "Información del vehículo",
      slug: "vehicle-info",
      content: vehicleInfoContent(),
    },
    {
      title: "Información del comprador y vendedor",
      slug: "business-info",
      content: businessInfoContent(),
    },
    {
      title: "Documentos compraventa",
      slug: "docs-info",
      content: docsInfoContent(),
    },
  ],
};

function TransferenceTypesContainer() {
  const screens = useBreakpoint();

  const bodyItemsStandard = [
    "Misma validez que presencial en notaría, pero desde donde quieras e incluso fines de semana.",
    "Puedes agregar TAG a domicilio y seguro automotriz."
  ];

  const bodyItemsExpress = [
    "Todo lo que ofrece la Estándar, pero más rápida.",
    "Garantizamos Gestión Prioritaria.",
    "Prioridad para firmas de notarios."
  ];
  return (
    <div id="container">
      <div>
        <Layout id="body">
          <Space direction="vertical" size={!screens["lg"] ? 24 : 35}>
            <HeaderContainer />
            <Layout
              style={{
                padding: "1rem",
                alignItems: "center",
                maxWidth: "1140px",
                margin: "auto",
                marginBottom: `${!screens["lg"] ? "290px" : "0"}`
              }}
            >
              <TextHeaderComponent headerText="Conoce las modalidades de Transferencia Online" />

              <Row style={{ justifyContent: "center" }}>
                <Col xs={24} md={20} style={{ maxWidth: "1024px" }}>
                  <Space size={24} direction="vertical">
                    <div>
                      <Row
                        style={{
                          paddingTop: `${!screens["lg"] ? "5px" : "16px"}`,
                          justifyContent: "center",
                        }}
                      >
                        <Col className="BodyContentStyles">
                          <Space size={16} direction="vertical">
                            <Row style={{ paddingBottom: "24px" }}>
                              <div>
                                <p className={"vehicle-buy-text-description"}>
                                  {
                                    <>
                                      {
                                        <span style={{ fontWeight: "600" }}>
                                          Antes de comenzar, podrás elegir entre
                                          dos tipos de transferencia:
                                        </span>
                                      }
                                      <br />
                                      {
                                        <span
                                          style={{
                                            fontWeight: "400",
                                            fontSize: "14px",
                                            paddingTop: "16px",
                                            display: screens.md
                                              ? "inline-block"
                                              : "none",
                                          }}
                                        >
                                          Recuerda, aquí exponemos el proceso de
                                          Transferencia a modo de ejemplo.
                                        </span>
                                      }
                                    </>
                                  }
                                </p>
                              </div>
                            </Row>
                          </Space>
                        </Col>
                      </Row>
                      <Row className="card-container">
                        <CardComponent
                          headerText="Transferencia Estándar"
                          bodyItems={bodyItemsStandard}
                          fillColor="#004CC6"
                        />
                        <CardComponent
                          headerText="Transferencia con Gestión Express"
                          bodyItems={bodyItemsExpress}
                          fillColor="#ff0000"
                        />
                      </Row>
                    </div>
                  </Space>
                  <Row style={{ justifyContent: "end" }}>
                    <Col md={12} xs={0}>
                      <NextBackBtnComponent
                        id="simTrf-step2-tag"
                        value={`/opciones/contrato-formulario`}
                        rowClassName="rowClassName"
                      ></NextBackBtnComponent>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Layout>
          </Space>
        </Layout>
        <Affix offsetBottom={1}>
          <div id="fix-mobile-footer" className="mobileStyle">
            <Row justify="center" align="middle" style={{ padding: "1rem" }}>
              <Col style={{ width: "50%" }}>
                <BackBtn label={"Volver"} title="Volver atrás"></BackBtn>
              </Col>
              <Col style={{ width: "50%" }}>
                <NextStepBtnComponent
                  id="simTrf-step1-contractform"
                  value="/opciones/contrato-formulario"
                  text={"Siguiente"}
                  action={() => {}}
                />
              </Col>
            </Row>
          </div>
        </Affix>
      </div>

      <div id="footer">
        <MinimalFooterComponent />
      </div>
    </div>
  );
}

export default TransferenceTypesContainer;
